<template>
  <nav class="main-nav">
    <div class="logo-placeholder">
      <img
        ref="logoImage"
        @load="
          () => {
            $emit('logo-loaded');
          }
        "
        fetchpriority="high"
        width="300"
        :src="logoSrc"
        class="attachment-full size-full wp-image-52310"
        alt=""
      />
    </div>

    <div
      class="nav-toggle"
      :class="{ 'toggle-menu-active': isMobileMenuActive }"
      @click="toggleMobileMenu"
    >
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>

    <div class="nav-menu" :class="{ 'mobile-menu-active': isMobileMenuActive }">
      <a href="https://city-electronique.fr/" class="nav-link mobile-menu-link"
        >Accueil</a
      >
      <template v-for="(item, index) in navItems" :key="index">
        <!-- Nav item with submenu -->
        <div
          v-if="item.submenu && item.submenu.length > 0"
          class="nav-item-wrapper has-submenu"
        >
          <a :href="item.href" class="nav-link mobile-menu-link menu-label">{{
            item.label
          }}</a>
          <button
            class="submenu-toggle"
            @click.prevent="toggleSubmenu(index)"
            aria-label="Toggle submenu"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
            </svg>
          </button>
          <div
            class="submenu"
            :class="{ 'active-submenu': activeSubmenuIndex === index }"
          >
            <a
              v-for="(subItem, subIndex) in item.submenu"
              :key="subIndex"
              :href="subItem.href"
              class="submenu-item"
              >{{ subItem.label }}</a
            >
          </div>
        </div>
        <!-- Nav item without submenu -->
        <a v-else :href="item.href" class="nav-link mobile-menu-link">{{
          item.label
        }}</a>
      </template>
      <a
        href="https://ia.city-electronique.fr/"
        class="boutique-button mobile-menu-link"
        >IA diagnostic</a
      >
    </div>
  </nav>
</template>

<script>
export default {
  name: "MainNav",
  data() {
    return {
      logoSrc: require("@/assets/city-electronique.png"),
      isMobileMenuActive: false,
      activeSubmenuIndex: null, // Track active submenu index
      navItems: [
        {
          label: "Nos services",
          href: "https://city-electronique.fr/choix-de-reparation-electronique/",
          submenu: [
            {
              label: "Réparation",
              href: "https://city-electronique.fr/choix-de-reparation-electronique/",
            },
            {
              label: "Modification de vos équipements",
              href: "https://city-electronique.fr/modification-personnalisee-de-vos-equipements/",
            },
            {
              label: "Nos réparations à tarif fixe",
              href: "https://city-electronique.fr/nos-reparations-a-tarif-fixe/",
            },
            {
              label: "Service de maintenance préventive",
              href: "https://city-electronique.fr/trouvez-la-solution-de-maintenance-adaptee-a-vos-equipements/",
            },
            {
              label: "Clonage de carte",
              href: "https://city-electronique.fr/clonage-de-carte/",
            },
            {
              label: "Boutique",
              href: "https://shop.city-electronique.fr/boutique/",
            },
            {
              label: "Pour les clients du Maroc",
              href: "https://city-electronique.fr/demande-de-service-pour-le-maroc/",
            },
          ],
        },
        {
          label: "Pannothèque",
          href: "https://city-electronique.fr/category/les-pannes-de-nos-clients/",
          submenu: [
            {
              label: "Explorez la pannothèque",
              href: "https://city-electronique.fr/category/les-pannes-de-nos-clients/",
            },
            {
              label: "Images",
              href: "https://city-electronique.fr/galerie-des-cartes/",
            },
            {
              label: "Types d'appareils réparés",
              href: "https://city-electronique.fr/des-centaines-dappareils-remis-en-service/",
            },
          ],
        },
        {
          label: "Références",
          href: "https://city-electronique.fr/approuve-par-les-clients-professionnels/",
          submenu: [], // No submenu for References
        },
        {
          label: "Contact",
          href: "https://city-electronique.fr/contact/",
          submenu: [
            {
              label: "L’équipe",
              href: "https://city-electronique.fr/lequipe-de-city-electronique/",
            },
            {
              label: "Vos questions",
              href: "https://city-electronique.fr/les-questions-frequentes/",
            },
          ],
        },
      ],
    };
  },
  emits: ["logo-loaded"],
  methods: {
    toggleMobileMenu() {
      this.isMobileMenuActive = !this.isMobileMenuActive;
      if (this.isMobileMenuActive) {
        this.activeSubmenuIndex = null; // Close submenu when menu is toggled open
      }
    },
    toggleSubmenu(index) {
      if (this.activeSubmenuIndex === index) {
        this.activeSubmenuIndex = null; // Close if already open
      } else {
        this.activeSubmenuIndex = index; // Open if closed or another is open
      }
    },
  },
};
</script>

<!-- <style scoped>
/* ... rest of your styles ... */
.submenu.active-submenu {
  display: block; /* Show submenu when active */
}
</style> -->

<style scoped>
.main-nav {
  background: white;
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative; /* Needed for absolute positioning of toggle */
}

.logo-placeholder {
  z-index: 101; /* Ensure logo is above mobile menu */
}

.nav-toggle {
  display: none; /* Hidden by default on larger screens */
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 30px;
  height: 30px;
  cursor: pointer;
  z-index: 101; /* Ensure toggle is above mobile menu */
}

.bar {
  width: 100%;
  height: 3px;
  background-color: #333; /* Or your desired color */
  margin: 6px 0;
  transition: transform 0.3s ease;
}

.nav-menu {
  display: flex;
  gap: 2rem;
  align-items: center;
  font-size: 18px;
  z-index: 100; /* Ensure menu is below toggle and logo */
}

.nav-item-wrapper {
  position: relative;
  cursor: pointer;
}

.nav-item-wrapper:hover .submenu {
  display: block;
}

.submenu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 0.5rem 0;
  min-width: 200px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.submenu-item {
  padding: 0.75rem 1rem 0.75rem 2rem;
  white-space: nowrap;
  border-bottom-style: solid;
  border-bottom-color: #3300668a;
  border-bottom-width: 1px;
  text-decoration: none; /* Remove underline */
  color: inherit; /* Inherit text color */
  display: block; /* Make the entire area clickable */
}

.submenu-item:hover {
  background: #f3f4f6;
}

.boutique-button {
  background: #330066;
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 1.5rem;
  border: none;
  cursor: pointer;
  font-size: 18px;
  text-decoration: none; /* Remove underline */
}

.nav-link {
  text-decoration: none; /* Remove underline */
  color: inherit; /* Inherit text color */
}

.submenu.active-submenu {
  display: block; /* Show submenu when active */
}

/* New styles for submenu toggle and layout */
.nav-item-wrapper.has-submenu {
  display: flex; /* Use flex to align label and toggle button */
  justify-content: space-between; /* Push label to left, toggle to right */
  align-items: center; /* Vertically align label and toggle */
}

.nav-item-wrapper.has-submenu > .nav-link.mobile-menu-link.menu-label {
  flex-grow: 1; /* Allow label to take available space */
  padding-right: 1rem; /* Add some spacing between label and toggle */
}

.submenu-toggle {
  background: none;
  border: none;
  padding: 1rem;
  cursor: pointer;
  display: flex; /* Center the SVG icon */
  align-items: center;
  justify-content: center;
  display: none;
}

.submenu-toggle svg {
  width: 1em; /* Adjust size as needed */
  height: 1em;
  fill: currentColor; /* Inherit text color */
}

/* Mobile Styles */
@media (max-width: 1280px) {
  .main-nav {
    flex-direction: column; /* Stack logo and nav items */
    align-items: flex-start; /* Align items to the start on mobile */
  }

  .logo-placeholder {
    margin-bottom: 1rem; /* Add space below logo on mobile */
    align-self: flex-start; /* Ensure logo aligns to the start */
  }

  .nav-toggle {
    display: block; /* Show hamburger toggle on mobile */
    top: calc(50% - 15px);
  }

  .nav-toggle.toggle-menu-active {
    top: 3rem;
  }

  .nav-menu {
    display: none; /* Hide nav menu by default on mobile */
    flex-direction: column; /* Stack menu items vertically on mobile */
    width: 100%;
    padding-top: 1rem; /* Add padding when menu is open */
    gap: 0; /* Remove gap between menu items in mobile view */
  }

  .nav-menu.mobile-menu-active {
    display: flex; /* Show mobile menu when active */
    align-items: flex-start;
  }

  .nav-menu.mobile-menu-active > .nav-link {
    width: 100%;
  }

  .nav-link.mobile-menu-link,
  .boutique-button.mobile-menu-link {
    display: block; /* Make nav links full width in mobile menu */
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid #e5e7eb; /* Add separator between mobile menu items */
    margin: 0.5rem;
  }

  .nav-item-wrapper {
    width: 100%; /* Make nav item wrappers full width in mobile menu */
  }

  .nav-item-wrapper:hover > .nav-link.mobile-menu-link,
  .nav-menu.mobile-menu-active
    > a.mobile-menu-link:hover:not(.boutique-button) {
    background: #f3f4f6; /* Hover effect for main mobile menu links */
  }

  .nav-item-wrapper:hover .submenu {
    display: block; /* Keep submenu display on hover even in mobile */
    position: relative; /* Position submenu relative to wrapper in mobile */
    box-shadow: none; /* Remove shadow for mobile submenu */
    border: none; /* Remove border for mobile submenu */
    width: 100%; /* Full width for mobile submenu */
  }

  .submenu {
    position: relative; /* Position submenu relative in mobile */
    top: 0; /* Reset top position */
    left: 0; /* Reset left position */
    box-shadow: none; /* Remove shadow for mobile submenu */
    border: none; /* Remove border for mobile submenu */
    width: 100%; /* Full width for mobile submenu */
    padding-left: 1rem; /* Indent submenu items */
  }

  .submenu-item {
    border-bottom: none; /* Remove border from submenu items in mobile */
    padding-left: 2rem; /* Adjust submenu item indentation */
    white-space: normal;
  }
  .submenu.active-submenu {
    flex-basis: 100%;
  }
  .nav-item-wrapper.has-submenu {
    flex-wrap: wrap;
  }
  .submenu-toggle {
    display: flex;
  }
}
</style>
